import { Button } from "@/components/ui/button";
import { Plus, DatabaseZap } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

interface FoodsHeaderProps {
  canManageFoods: boolean;
  onAddFood: () => void;
  onSearchOFF?: () => void;
}

export function FoodsHeader({
  canManageFoods,
  onAddFood,
  onSearchOFF,
}: FoodsHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between mb-6">
      <div>
        <h1 className="text-3xl font-bold">{t("foods:title")}</h1>
        <p className="text-muted-foreground">{t("foods:subtitle")}</p>
      </div>
      {canManageFoods && (
        <div className="flex gap-2">
          {onSearchOFF && (
            <Button variant="outline" onClick={onSearchOFF}>
              <DatabaseZap className="h-4 w-4 mr-2" />
              {t("foods:searchOFF")}
            </Button>
          )}
          <Button onClick={onAddFood}>
            <Plus className="h-4 w-4 mr-2" />
            {t("foods:addFood")}
          </Button>
        </div>
      )}
    </div>
  );
}
